<template>
  <div>
    <label :class="{'input-required': required === true}">{{titulo}}</label>
    <mcx-multi-select
      v-model="selected"
      :options="options"
      :multiple="multiple"
      :close-on-select="!multiple"
      :allow-empty="true"
      :preserve-search="true"
      placeholder="Selecione um portal"
      select-label=""
      deselect-label=""
      selected-label=""
      label="Nome"
      track-by="Id"
      :preselect-first="false"
      :group-select="true"
      :group-label="multiple ? 'selTodos' : null"
      :group-values="multiple ? 'valores' : null"
      select-group-label=""
      deselect-group-label=""
      :isInvalid="isinvalidportal"
    >
    <template v-if="!multiple" slot="singleLabel" slot-scope="props">
      <span class="option__desc">
        <span class="option__title">
          <div class="truncate">{{props.option.Nome}}</div>
        </span>
      </span>
    </template>

      <template v-if="multiple" slot="selection" slot-scope="select">
        <span class="multiselect__single" v-if="select.values.length == 1 && !select.isOpen">
          <div
            :key="item.Id"
            v-for="item in select.values"
            class="truncate"
          >{{ item.Nome }}</div>
        </span>
        <span
          class="multiselect__single"
          v-if="select.values.length > 1 && !select.isOpen"
          style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
        >{{ select.values.length }} Portais selecionados</span>
      </template>
      <span slot="noResult">Nenhum registro encontrado.</span>
      <span slot="noOptions">Selecione um Portal.</span>
    </mcx-multi-select>
    <div :class="{'invalid-feedback': true,'d-block': isinvalidportal}">
      <span>Você deve selecionar um portal</span>
    </div>
  </div>
</template>

<style scoped>

.truncate {
  width: 95%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>

<script>
import Vue from "vue";
import Multiselect from "vue-multiselect";
var mcxMultiSelect = {
  extends: Multiselect,
  props: {
    isInvalid: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isInvalid: function(val, oldValue) {
      this.$refs.tags.classList.remove("form-control");
      this.$refs.tags.classList.remove("is-invalid");

      if (val) {
        this.$refs.tags.classList.add("form-control");
        this.$refs.tags.classList.add("is-invalid");
      }
    }
  }
};

Vue.component("mcx-multi-select", mcxMultiSelect);

import LMA from "../assets/Microservices/LMAClient.superagent";
import routes from "../assets/Microservices/Routes/BIRoutes";
import loading from "../assets/js/loading/";
import swal from "../assets/js/alerts/";
import store from "../store/";

export default {
  name: "SelectPortal",
  props: ["model", "titulo", "required", "multiple", "isinvalidportal"],
  data() {
    return {
      options: [],
      selected: []
    };
  },
  watch: {
    selected: function() {
      this.$emit("input", this.selected);
    }
  },

  mounted: function() {
    this.options = this.popularSelecionarTodosMultiselect(
      store.getters.getFiltrosGlobais().FiltroPortalEmpresa
    );

    const filtroPortaisEmpresas = store.getters.getFiltrosGlobais().FiltroPortaisEmpresas;
    if (filtroPortaisEmpresas) {
      const portais = JSON.parse(filtroPortaisEmpresas).Portais;

      this.selected = this.options[0].valores.filter(portal =>
        portais.includes(String(portal.Id))
      );
    }
  },

  methods: {
    getGroupLabel: function() {

    },
    customLabel: function(obj) {
      return obj.Nome;
    },
    popularSelecionarTodosMultiselect: function(comboAdicionarTodos) {
      if (!this.multiple) return comboAdicionarTodos;

      var objAddTodos = new Array();
      var objCombo = new Object();
      objCombo.selTodos = "Selecionar Todos";
      objCombo.valores = comboAdicionarTodos;
      objAddTodos.push(objCombo);
      return objAddTodos;
    }
  }
};
</script>